<div class="login-container">
  <div class="login-background">
    <div class="shape"></div>
    <div class="shape"></div>
  </div>
  
  <div class="login-content">
    <div class="logo-container">
      <img src="assets/images/nri-logo-white.png"  alt="Logo" class="logo">
    </div>
    
    <div class="login-card">
      <div class="login-header">
        <h2>Reset Password</h2>
        <p>Create a new password for your account</p>
      </div>
      
      <form [formGroup]="resetPasswordForm" class="login-form">
        <div class="mb-0 position-relative">
          <div class="position-relative password-wrapper">
            <div style="width: 100%">
              <app-text-input
                label="Password"
                placeholder="Password"
                [type]="isPasswordVisible ? 'text' : 'password'"
                [control]="getControl('password')"
                (input)="onPasswordInput()"
              >
              </app-text-input>
              <i
                class="fa"
                [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"
                (click)="togglePasswordVisibility()"
              ></i>
                           <div *ngIf="getControl('password').invalid && getControl('password').touched" class="password-align">
     <div *ngIf="passwordErrors?.['noLowercase']" class="pwd-format-text ">Must contain a lowercase letter</div>
<div *ngIf="passwordErrors?.['noUppercase']" class="pwd-format-text ">Must contain an uppercase letter</div>
<div *ngIf="passwordErrors?.['noNumber']" class="pwd-format-text ">Must contain a number</div>
<div *ngIf="passwordErrors?.['noSpecialChar']" class="pwd-format-text ">Must contain a special character (&#64;$!%*?&)</div>
<div *ngIf="passwordErrors?.['tooShort']" class="pwd-format-text ">Minimum 8 characters required</div>

    </div>
            </div>
          </div>
        </div>
        <div class="mb-0 position-relative">
          <div class="position-relative password-wrapper">
            <div style="width: 100%">
              <app-text-input
                label="Confirm Password"
                placeholder="Confirm Password"
                [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                [control]="getControl('confirmPassword')"
                (input)="onPasswordInput()"
              >
              </app-text-input>
              <i
                class="fa"
                [ngClass]="
                  isConfirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash'
                "
                (click)="toggleConfirmPasswordVisibility()"
              ></i>
              <div
                *ngIf="
                  passwordMismatch && getControl('confirmPassword').dirty
                "
                class="text-danger"
                style="font-size: 13px;
                margin-top: -15px;
                margin-bottom: 15px;"
              >
                Password and Confirm Password do not match
              </div>
            </div>
          </div>
        </div>

        <div class="form-group mt-1">
          <button 
            type="submit" 
            class="btn btn-primary w-100" (click)="resetPassword()"
            [disabled]="resetPasswordForm.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isLoading ? 'Resetting...' : 'Reset Password' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
